import { RiskState, Reducer, RiskStateAction, ReducerActions, riskStateActions } from '@/context/types';
import { FormDeepKeys, FormTrucker, KeyValue } from '@/types';

export const getEmptyTrucker = (): FormTrucker => ({
  address: {
    location: undefined,
    neighborhood: '',
    number: '',
    street: '',
    zipCode: '',
    complement: '',
  },
  cnh: {
    category: undefined,
    stateEmission: undefined,
    dateFirstLicense: '',
    registrationNumber: '',
    securityNumber: '',
    expirationDate: '',
  },
  birthday: '',
  cellPhone: '',
  cpf: '',
  fatherName: '',
  motherName: '',
  name: '',
  type: 'Autônomo',
  profileId: null,
  riskId: null,
  isRegistered: undefined,
  isSelfValid: undefined,
  isDriverPhone: undefined,
});

const getInitialData = () => ({
  truck: {
    typeName: '',
    typeId: '',
    compositions: [],
  },
  trucker: getEmptyTrucker(),
  travel: {
    cargoType: '',
    cargoValue: '0',
    destinationPlace: undefined,
    originPlace: undefined,
    freightId: '',
  },
});

const makeRiskInitialState = (): RiskState => ({
  backendResponse: getInitialData(),
  data: getInitialData(),
  isLoading: true,
  isValid: false,
  triedToSubmit: false,
  isLoadingSubmit: false,
  showUnofficialPhoneAlert: false,
  farePaid: false,
  auth: {
    user: { typeDescription: null, id: null, company: { id: null, combo: { uuid: null, name: null } } },
    loaded: false,
  },
});

const reducerActions: ReducerActions<RiskState, RiskStateAction> = (state, payload) => ({
  risk_load_start: () => ({ ...state, isLoading: true }),
  risk_load_end: () => ({ ...state, isLoading: false }),
  risk_store_error: () => ({ ...state, isLoading: false }),
  risk_update_data: () => ({ ...state, data: { ...payload } }),
  risk_update_trucker: () => ({ ...state, data: { ...state.data, trucker: payload } }),
  risk_update_backend_response: () => ({ ...state, backendResponse: { ...payload } }),
  risk_set_is_valid: () => ({ ...state, isValid: payload }),
  risk_set_tried_to_submit: () => ({ ...state, triedToSubmit: payload }),
  set_fare_paid: () => ({ ...state, farePaid: payload }),
  set_submit_load: () => ({ ...state, isLoadingSubmit: payload }),
  set_show_unofficial_phone_alert: () => ({ ...state, showUnofficialPhoneAlert: payload }),
  set_auth_state: () => ({ ...state, auth: payload }),
  risk_form_reset: () => ({ ...makeRiskInitialState(), isLoading: state.isLoading, auth: state.auth }),
  risk_update_field: () => {
    const { field, value } = payload as { field: FormDeepKeys; value: any };
    const { ...data } = state.data;
    let dataRef = data as KeyValue;
    const fieldList = field
      .split(/\W+/g)
      .reduce<string[]>((prev, current) => [...prev, ...(!!current ? [current] : [])], []);

    const lenght = fieldList.length;

    for (let i = 0; i < lenght - 1; i++) {
      const elem = fieldList[i];
      if (!dataRef[elem]) dataRef[elem] = {};
      dataRef = dataRef[elem] as KeyValue;
    }

    dataRef[fieldList[lenght - 1]] = value;

    return { ...state, data: { ...data } };
  },
});

export const riskReducer: Reducer<RiskState, RiskStateAction> = (state, { action, payload }) =>
  riskStateActions.includes(action) ? reducerActions(state, payload)[action]() : { ...state };

riskReducer.key = 'risk';
riskReducer.initialState = makeRiskInitialState();
